import { DialogProps } from '@mui/material';

import { ClassSessionRecord } from '../../../../models/types';
import { RecordingStatus } from '../../types/recordingTypes';

export type Permission = 'PUBLIC' | 'ROSTER' | 'ADMINS';

export interface ClassRecording {
    recordingId: string;
    name: string;
    permission: Permission;
    status: RecordingStatus;
    when: string; // ISO date string
    duration: number; // Seconds
    size: number; // Total bytes for all recording artifacts.
}

export enum LmsType {
    Blackboard = 'blackboard',
    Canvas = 'canvas',
    D2l = 'd2l',
    Moodle = 'moodle',
    OpenLms = 'openlms',
    Schoology = 'schoology'
}

export interface ClassRecordingFormFields {
    name: string;
    permission: Permission;
}

export interface ClassSessionWithRecording extends ClassSessionRecord {
    recordings?: ClassRecording[];
}

export type RecordingDialogProps = DialogProps & {
    downloading: boolean;
    recording?: ClassRecording;
    recordings: ClassRecording[];
    setRecordings: (recordings: ClassRecording[]) => void;
};
